import { type VideocmsElement } from '@@editor/helpers/Element';

const getVideocmsPreviewImage = (element: VideocmsElement) => element.data.embed?.previewImage;

export default getVideocmsPreviewImage;
